import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const InlineUpgradeButton = ({ className, text, onClick, ...restProps }) => {
  const styles = useStyles();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <span
      className={cx(styles.root, className)}
      onClick={handleClick}
      {...restProps}
    >
      {text || 'Upgrade'}
    </span>
  );
};

InlineUpgradeButton.displayName = 'InlineUpgradeButton';

InlineUpgradeButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

InlineUpgradeButton.defaultProps = {
  className: null,
  text: null,
};
